import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
}                           from '@angular/router';


import { TokenStorageService } from '../_service/token-storage.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private tokenStorageService: TokenStorageService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   debugger ;
    var cc = !!this.tokenStorageService.isLoggedIn();
 
    const token = this.tokenStorageService.getToken();
    let context = this;

    window.addEventListener("beforeunload", function (e) {
      debugger
      let currentUser = context.tokenStorageService.isLoggedIn();
     
      
      if (currentUser == true && route.url.length == 0) {
        context.tokenStorageService.signOut();
        
      }
     
    });

    
    // not logged in so redirect to login page with the return url and return false
    if (cc && route.url.length != 0) {
      // logged in so return true
      //this.tokenStorageService.getToken();
      return true;
    }
    context.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
    //context.tokenStorageService.signOut();
    return false; 
   // this.authService.setActiveMenu(route_data.menu_key);

    //if (cUser) {
    //  // logged in so return true
    //  this.tokenStorageService.getToken();
    //  return true;
    //}
    

  }

}
